import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { Card, Icon, ListItem } from '@sel/ui';
import { entries } from '@sel/utils';

import { navigation, type NavigationItem } from 'src/app/routes';
import { useSignOut } from 'src/app/session';
import { Link } from 'src/components/link';
import { PageTitle } from 'src/components/page-title';

export function NavigationPage() {
  const { i18n } = useLingui();

  const labels: Partial<{ [Group in keyof typeof navigation]: MessageDescriptor }> = {
    exchanges: msg`Exchanges`,
    community: msg`Community`,
    account: msg`My account`,
  };

  return (
    <div className="mx-auto stack max-w-content gap-6">
      <PageTitle title={msg`More`} />

      {entries(navigation).map(([group, items]) => (
        <section key={group} className="stack gap-2">
          {labels[group] && <h2 className="text-caption text-subtle">{i18n._(labels[group])}</h2>}
          <Card.Root>
            <ul>
              {Object.values(items).map((entry) => (
                <Entry key={entry.path} {...entry} />
              ))}
              {group === 'account' && <SignOutItem />}
            </ul>
          </Card.Root>
        </section>
      ))}
    </div>
  );
}

function Entry({ path, label, icon }: NavigationItem) {
  const { t } = useLingui();

  return (
    <ListItem.Root>
      <Icon name={icon} className="text-muted" />
      <ListItem.Content>
        <ListItem.Title>
          <ListItem.Link Link={Link} href={path}>
            {t(label)}
          </ListItem.Link>
        </ListItem.Title>
      </ListItem.Content>
      <ListItem.Chevron />
    </ListItem.Root>
  );
}

function SignOutItem() {
  const signOut = useSignOut();

  return (
    <ListItem.Root>
      <Icon name="sign-out" className="text-muted" />
      <ListItem.Content>
        <ListItem.Title>
          <ListItem.Button onClick={signOut}>
            <Trans>Sign out</Trans>
          </ListItem.Button>
        </ListItem.Title>
      </ListItem.Content>
    </ListItem.Root>
  );
}
